module.exports = __webpack_public_path__ + "static/media/SELLOSDEPOZO.3b75aa54.png";